export { handlerClickConfiguration } from './Configuration'
export { handlerOpenModalChangePassword } from './Password'
export { handlerLogout } from './Logout'
export { fullScreen } from './FullScreen'